var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"f6 fw6 link dim ph3 pv2 dib black bg-white lh-copy roboto sans-serif ttu tracked tc",on:{"click":function($event){return _vm.changeLanguage()}}},[_vm._v(" "+_vm._s(_vm.currentLanguage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }